export const STORE_ASSESSMENT = 'STORE_ASSESSMENT';
